getWebContext = require './get-web-context'
logTracking = require './log-tracking'
trackGoogleTagManager = require './trackGoogleTagManager'
idleTaskScheduler = require('common/lib/util/idleTaskScheduler').default

module.exports = (category, action, label, property, value) ->
  idleTaskScheduler.addTask ->
    if typeof property == 'number'
      value = property
      property = undefined
    window.ga? 'send', 'event', category, action, label, value
    webContext = getWebContext()
    window.sp? 'trackStructEvent:cf', category, action, label, property, value, webContext
    trackGoogleTagManager.push
      event: 'snowplow.event'
      snowplowEvent: {
        context: webContext
        category
        action
        label
        property
        value
      }
    logTracking { category, action, label, property, value }



// WEBPACK FOOTER //
// ./app/scripts/debug/track.coffee